export default "__VITE_ASSET__eW6k6Art__"